import React, { useEffect, useRef, useState } from 'react';
import SingleThread from './SingleThread';
import TagUserForm from './TagUserForm';

import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import CommonUploadFile from '../../Utilities/CommonUploadFile';
import ComPatSearch from './ComPatSearch';
import { useDispatch, useSelector } from 'react-redux';
import { handleGlobalReload } from '../../redux/slices/appSlice';

function SingleMsgView({ data, handleReload = () => {}, replymsgFlag }) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload } = useSelector((store) => store.app);

  const [tagUserForm, setTagUserForm] = useState(false);
  const [attachments, setAttachments] = useState('');
  const [attachedPatientIds, setAttachedPatientIds] = useState('');
  const [taggedUserStr, setTaggedUserStr] = useState(data?.taggedUser || '');
  const divRef = useRef(null);
  const [textMsg, setTextMsg] = useState('');
  let tagUser = false;
  let dispSub = false;
  let dispIcon = true;
  if (data?.type === '1' || (data?.type === '2' && data?.is_thread === '1')) {
    tagUser = true;
  }
  if (data?.type === '2' || data?.type === '3') {
    dispSub = true;
  }
  if (data?.type === '3') {
    dispIcon = false;
  }

  useEffect(() => {
    if (divRef.current) {
      divRef.current.scrollTop = divRef.current.scrollHeight;
    }
  }, [data]);

  const handleReplyMsg = async () => {
    let prams = {
      msgId: data?.parentId, // msg parent Id
      msgType: data?.type, // 1,2,3
      from: data?.fromuser,
      to: data?.touser,
      loginUserId: user?.id,
      msg: textMsg.trim(),
      isThread: '0', //0 or 1
      attachments: '',
      attachedPatientIds: '',
    };
    if (data?.type === '2') {
      if (data?.is_thread === '1') {
        prams = {
          ...prams,
          isThread: '1', //0 or 1
        };
      } else {
        prams = {
          ...prams,
          attachments: attachments,
        };
      }
    } else if (data?.type === '3') {
      prams = {
        ...prams,
        attachments: attachments,
        attachedPatientIds: attachedPatientIds,
      };
    }
    if (!!prams.msg) {
      try {
        const response = await post(
          'api/communication/Communication/replyMsg',
          {
            ...prams,
          }
        );
        if (response?.status === 200) {
          setTextMsg('');
          handleReload();
          replymsgFlag();
          dispatch(handleGlobalReload(!globalReload));
          if (response?.data?.status === 'smssent') {
            setUiMessage('suc', 'Message sent successfully.');
          }
          if (response?.data?.status === 'success') {
            setUiMessage('suc', 'Message sent successfully.');
          }
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    } else {
      setUiMessage('err', 'Please write some message.');
    }
  };

  return (
    <div className="comm-centre-text-sec grid-sec">
      <div
        className="txt-thread-chrt width100 qflex-sec"
        style={{ float: 'left' }}
      >
        {dispIcon && (
          <span
            className="view-com-icon hide"
            dangerouslySetInnerHTML={{
              __html: data?.msgIcon,
            }}
          ></span>
        )}

        <span
          className="com-icon hide"
          style={{ width: '35px', margin: '5px 0px 0px 10px', float: 'left' }}
        >
          <img
            style={{ width: '80%', marginTop: '5px' }}
            src={data?.msgIcon}
            alt=""
          />
        </span>

        {dispSub && (
          <span
            className="sndrcv-lt-msg qbold"
            style={{
              width: '85%',
              padding: '5px 10px 12px 10px',
              fontSize: '1.2vw',
              float: 'left',
            }}
          >
            {data?.subLine}
          </span>
        )}

        {tagUser && (
          <div className="qflex-sec clear-top10" style={{ float: 'right' }}>
            {taggedUserStr && (
              <span
                className="txt-thread-chrt flex-sec"
                style={{
                  padding: '5px 10px 12px 10px',
                  width: '100%',
                  margin: '0px 0px 5px 0px',
                }}
              >
                <b>Tagged User:&nbsp;</b>
                {`${taggedUserStr}`}
              </span>
            )}

            <button
              className={`actn-yes ${data?.replyAccess === '0' ? 'hide' : ''}`}
              style={{ width: '100%', margin: '0px 12px 5px 0px' }}
              onClick={() => setTagUserForm(true)}
            >
              Tag user
            </button>
          </div>
        )}
      </div>
      <div className="comm-centre-text-sec-bdy content-line-break" ref={divRef}>
        {data?.threadList &&
          data?.threadList.map((item, i) => {
            return <SingleThread key={i} data={item} type={data?.type} />;
          })}
      </div>

      <div
        className={`comm-centre-thread-text-reply ${
          data?.replyAccess === '0' ? 'hide' : ''
        }`}
      >
        <textarea
          className="comm-txt-reply"
          placeholder="Write your reply here..."
          value={textMsg}
          onChange={(e) => setTextMsg(e.target.value)}
          autoFocus
        ></textarea>
        {(data?.type === '3' ||
          (data?.type === '2' && data?.is_thread === '0')) && (
          <div className="flex-sec" style={{ width: 'calc(100% - 15px)' }}>
            <div className="flex-sec width100">
              <span className="com-atchmnt-lbl fontsize12">{'Document'}:</span>
              <CommonUploadFile
                // lable={'Attachment'}
                apiUri={'api/communication/Communication/uploadImageForReply'}
                handleUploadFile={(fileNameStr) => setAttachments(fileNameStr)}
              />
            </div>

            {!(data?.type === '2' && data?.is_thread === '0') && (
              <div className="flex-sec width100">
                <ComPatSearch
                  fieldName={'Patients'}
                  handlePatArr={(pats) => setAttachedPatientIds(pats)}
                  returntype={'str'}
                  bigSearchBox={true}
                />
              </div>
            )}
          </div>
        )}

        <div className="comp-msg-ftr flex-sec revrse-dir">
          <button className="actn-yes" onClick={handleReplyMsg}>
            Send
          </button>
        </div>
      </div>
      {tagUserForm && (
        <TagUserForm
          closeDialog={() => setTagUserForm(false)}
          msgI={data?.parentId}
          msgType={data?.type}
          tagUserStr={(str) => setTaggedUserStr(str)}
        />
      )}
    </div>
  );
}

export default SingleMsgView;
